export default __webpack_public_path__ + "static/media/screen.526f6dfe.png";